import React from 'react';
export const TriageSessionContext = React.createContext(null);
export function useTriageSession() {
    const result = React.useContext(TriageSessionContext);
    if (!result) {
        throw new Error('useTriageSession should be used inside TriageSessionContext');
    }
    return result;
}
